// @flow

import React from 'react';
import moment from 'moment-timezone';

// header

type Props = {
    articleItem: { [key: string]: any }
};

const Article = (props: Props) => {
    const display = (
        <div key={props.articleItem.id} className={'article'}>
            <a href={props.articleItem.permalink} target={'_blank'}>
                <div>{props.articleItem.title}</div>
            </a>
            <div className={'article-date'}>
                {moment(props.articleItem.modified_date).format('MM/DD/YYYY')} by {props.articleItem.author}
            </div>
        </div>
    );

    return display;
};

export default Article;



// WEBPACK FOOTER //
// ./src/components/Main/PlayerCard/Articles/Article.js